/* eslint-disable no-param-reassign */
import Vue from 'vue';
import firebase from '../../firebase';

const moduleState = {
  edit: false,
  title: 'Kauneus & hyvinvointipalvelut',
  hero: {},
  news: [],
  content: [],
  color: {
    primary: '#C5B358',
  },
  uploadValue: 0,
  uploading: false,
};

const getters = {
  content: ({ content }) => content,
};

const mutations = {
  READ(state, data) {
    state.content = data.state.content;
    state.title = data.state.title;
    state.news = data.state.news;
    state.hero = data.state.hero;
    state.color = data.state.color || {};
  },
  UPLOADING(state, data) {
    state.uploading = data;
  },
  UPLOADSTATUS(state, data) {
    state.uploadValue = data;
  },
  SETITEMS(state, data) {
    state.content.items = data;
  },
};

const actions = {
  setItems({ commit }, items) {
    commit('SETITEMS', items);
  },
  async read({ commit }) {
    const content = await firebase.database().ref('content').once('value');
    commit('READ', content.val());
  },
  async save() {
    const state = { ...moduleState };
    state.content.items.forEach((c) => {
      if (c.pageTitle) {
        Vue.set(c, 'tab', c.pageTitle);
      }
    });
    await firebase.database().ref('content').set({
      state,
    });
    window.location.reload();
  },
  async listImages() {
    const images = await firebase.database().ref('images').once('value');
    return images.val();
  },
  async listHeroImages() {
    const images = await firebase.database().ref('heroImages').once('value');
    return images.val();
  },
  upload({ commit }, file) {
    commit('UPLOADING', true);
    const storageRef = firebase
      .storage()
      .ref(`${Date.now()}_${file.name}`)
      .put(file);

    storageRef.on(
      'state_changed',
      (snapshot) => {
        commit('UPLOADSTATUS', (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        commit('UPLOADING', true);
      },
      (error) => {
        console.log(error.message);
      },
      async () => {
        const url = await storageRef.snapshot.ref.getDownloadURL();
        await firebase
          .database()
          .ref('images')
          .push(url);
        commit('UPLOADSTATUS', 0);
        commit('UPLOADING', false);
      },
    );
  },
  uploadHero({ commit }, file) {
    commit('UPLOADING', true);
    const storageRef = firebase
      .storage()
      .ref(`${Date.now()}_${file.name}`)
      .put(file);

    storageRef.on(
      'state_changed',
      (snapshot) => {
        commit('UPLOADSTATUS', (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      },
      (error) => {
        console.log(error.message);
      },
      async () => {
        commit('UPLOADSTATUS', 0);

        const url = await storageRef.snapshot.ref.getDownloadURL();
        await firebase
          .database()
          .ref('heroImages')
          .push(url);
        commit('UPLOADING', false);
      },
    );
  },
};

export default {
  namespaced: true,
  state: moduleState,
  getters,
  mutations,
  actions,
};
